module.exports = __webpack_public_path__ + "static/media/closeCross.9f6afa15.svg";